<template>
  <div class="projbid-reply-preview">
    <ProjBidReplyHeader />
    <div class="panel-box">
      <ProjectViewSummary class="viewSummary" :project="project" />
    </div>
    <div class="eb-line"></div>
    <div class="rule-answer-view">
      <ProjRuleAnswerViewList :ruleAnswerList="ruleAnswerList" />
    </div>
    <ProjectViewHandsontable class="panel-box" :title="projectHandsontableTitle" :hotSettings="shoppingListHotSettings" :total="reply.quoteMin"
      :isTotalShow="true" />
    <div class="eb-line"></div>
    <ProjectViewPreText class="panel-box" :title="projectViewCommentTitle" :content="project.projectComment" />
    <div class="eb-line"></div>
    <ProjectViewPreText class="panel-box" :title="projectViewquoteStatementTitle" :content="reply.quoteStatement" />
    <div class="eb-line"></div>
    <div class="eb-button-group">
      <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="prevClick">&lt; 分项报价表</el-button>
      <el-button :loading="buttonLoading" class="eb-button-group-btn eb-button-orange eb-button-big" @click="isAythPublishQuote">提交报价 &gt;</el-button>
    </div>
  </div>
</template>
<script>
import ProjBidReplyHeader from '@/components/project/bid/reply/ProjBidReplyHeader';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import ProjRuleAnswerViewList from '@/components/project/common/rule-answer-view/ProjRuleAnswerViewList';
import ProjectViewHandsontable from '@/components/project/common/ProjectViewHandsontable';
import ProjectViewPreText from '@/components/project/common/ProjectViewPreText';
import { detailProjectResponse, getTimeAndStauts, isCheckSupplierBtnAuth } from '@/services/proj/bid-project-service';
import { listAnswer } from '@/services/proj/bid-rule-answer-service';
import { handleProjRuleAnswerList } from '@/services/proj/project-service';
import { listSupplier } from '@/services/proj/bid-shopping-list-service';
import { getReplyById, editReply } from '@/services/proj/bid-reply-service';
export default {
  name: 'ProjBidReplyPreview',
  components: {
    ProjBidReplyHeader,
    ProjectViewSummary,
    ProjRuleAnswerViewList,
    ProjectViewHandsontable,
    ProjectViewPreText
  },
  filters: {},
  data() {
    return {
      projectId: this.$route.params.projectId,
      replyId: this.$route.params.replyId,
      user: this.$store.state.user.userInfo,
      project: {},
      ruleAnswerList: [],
      buttonLoading: false,
      reply: {},
      btnParams: {
        projectId: this.$route.params.projectId,
        type: '3'
      },
      projectHandsontableTitle: {
        number: '1',
        text: '分项报价表'
      },
      projectViewCommentTitle: {
        number: '2',
        text: '报价表备注'
      },
      projectViewquoteStatementTitle: {
        number: '3',
        text: '报价声明'
      },
      shoppingListHotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['名称', '描述', '单位', '数量', '单价(投标方填写)', '总价', '备注'],
        renderAllRows: true,
        fillHandle: false,
        data: [],
        columns: [
          {
            data: 'productName',
            type: 'text',
            width: 90,
            readOnly: true
          },
          {
            data: 'productDesc',
            type: 'text',
            width: 430,
            readOnly: true
          },
          {
            data: 'productUnit',
            type: 'text',
            width: 40,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'productNum',
            width: 70,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'supplierPrice',
            width: 140,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'supplierSubtotal',
            width: 110,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'remark',
            width: 70,
            renderer: 'html',
            className: 'htCenter',
            readOnly: true
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let [{ data: data1 }, { data: data2 }, { data: data3 }, { data: data4 }] = await Promise.all([
          detailProjectResponse(this.projectId), // 获取招标项目详情，包含shopList,project
          listAnswer(this.projectId, this.user.userid), // 获取获取规则应答明细
          listSupplier(this.projectId, this.user.userid), // 获取应答shoplist
          getReplyById(this.projectId, this.user.userid)
        ]);
        if (data1.returnCode === '01') {
          this.project = data1.project;
        } else if (data1.returnCode === '00') {
          this.$confirm('您无权访问此项目。项目不存在，或已经被撤回/取消。', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'eb-cancle-button',
            cancelButtonClass: '',
            type: '',
            center: true,
            showClose: false,
            customClass: 'eb-comfirm',
            showCancelButton: false
          })
            .then(() => {
              this.$router.push('/projbid/quoted/list');
            })
            .catch(() => {
              this.$router.push('/projbid/quoted/list');
            });
        } else {
          throw new Error('加载项目详情失败！');
        }
        if (data2.returnCode === '01') {
          this.ruleAnswerList = handleProjRuleAnswerList(data2.ruleList);
          this.changeTitleNumber(parseInt(this.ruleAnswerList.length));
        } else {
          throw new Error('加载项目规则应答列表失败');
        }
        if (data3.returnCode === '01') {
          this.shoppingListHotSettings.data = data3.supplierList;
        } else if (data3.returnCode === '00') {
        } else {
          throw new Error('加载应答清单失败');
        }
        if (data4.returnCode === '01') {
          this.reply = data4.reply;
        } else {
          throw new Error('加载应答项目详情失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    changeTitleNumber: function(number) {
      this.projectHandsontableTitle.number = number + 1;
      this.projectViewCommentTitle.number = number + 2;
      this.projectViewquoteStatementTitle.number = number + 3;
    },
    async prevClick() {
      try {
        let { data } = await isCheckSupplierBtnAuth(this.btnParams);
        if (data.returnCode === '01') {
          this.$router.push('/projbid/reply/purchaselist/' + this.projectId + '/' + this.replyId);
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error('网络异常请稍后重试');
      }
    },
    // 提交应答
    async isAythPublishQuote() {
      try {
        let { data } = await isCheckSupplierBtnAuth(this.btnParams);
        if (data.returnCode === '01') {
          this.publishQuote();
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error('网络异常请稍后重试');
      }
    },
    async publishQuote() {
      let text = '确认提交报价吗？';
      let confirmButtonText = '确定';
      let cancelButtonText = '取消';
      let title = '';
      if (!this.reply.quoteMin) {
        text = '您的报价为0元，请检查采购清单中的价格后再进行提交报价。';
        confirmButtonText = '强行提交';
        cancelButtonText = '返回修改';
        title = '零元报价提示';
      }
      this.$ebConfirm(text, title, {
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText
      })
        .then(() => {
          this.getTimeAndStautsService();
        })
        .catch(() => {});
    },
    async getTimeAndStautsService() {
      try {
        let { data } = await getTimeAndStauts(this.projectId);
        if (data.returnCode === '01') {
          this.editReply1Service();
        } else if (data.returnCode === '04') {
          this.$message.error('项目已截止或采购方已关闭项目，您无法提交报价。');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async editReply1Service() {
      this.buttonLoading = true;
      try {
        let params = {
          projectId: this.projectId,
          supplierDepartId: this.user.departId,
          updateId: this.user.userid,
          replyId: this.replyId,
          quoteStatus: 9
        };
        let { data } = await editReply(params);
        if (data.returnCode === '01') {
          this.$message.success('提交报价成功');
          this.$router.push('/projbid/quoted/list');
        } else {
          this.$message.error('提交报价失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.buttonLoading = false;
    }
  }
};
</script>
<style lang="less">
</style>
